export default __webpack_public_path__ + "static/media/what-we-do-desktop-ellipse-small.e66e0b0e.svg";